import enUS from 'date-fns/locale/en-US/index';
import ar from 'date-fns/locale/ar/index';
import ru from 'date-fns/locale/ru/index';
import de from 'date-fns/locale/de/index';
import fr from 'date-fns/locale/fr/index';
import {format, parse, formatDistance, formatRelative} from 'date-fns';

function getLocaleFile() {
    const {locale} = useI18n();
    let langFile = enUS;
    switch (locale.value) {
        case 'en':
            langFile = {
                ...enUS,
                formatDistance: (token, count, options) => {
                    const result = {
                        lessThanXSeconds: `${count}s`,
                        xSeconds: `${count}s`,
                        halfAMinute: '0.5m',
                        lessThanXMinutes: `${count}m`,
                        xMinutes: `${count}m`,
                        aboutXHours: `${count}h`,
                        xHours: `${count}h`,
                        xDays: `${count}d`,
                        aboutXWeeks: `${count}w`,
                        xWeeks: `${count}w`,
                        aboutXMonths: `${count}mo`,
                        xMonths: `${count}mo`,
                        aboutXYears: `${count}y`,
                        xYears: `${count}y`,
                        overXYears: `${count}y`,
                        almostXYears: `${count}y`
                    };

                    return result[token];
                }
            }
            break
        case 'ru':
            langFile = {
                ...ru,
                formatDistance: (token, count, options) => {
                    const result = {
                        lessThanXSeconds: `${count}с`,
                        xSeconds: `${count}с`,
                        halfAMinute: '0.5м',
                        lessThanXMinutes: `${count}м`,
                        xMinutes: `${count}м`,
                        aboutXHours: `${count}ч`,
                        xHours: `${count}ч`,
                        xDays: `${count}д`,
                        aboutXWeeks: `${count}н`,
                        xWeeks: `${count}н`,
                        aboutXMonths: `${count}мес`,
                        xMonths: `${count}мес`,
                        aboutXYears: `${count}л`,
                        xYears: `${count}л`,
                        overXYears: `${count}л`,
                        almostXYears: `${count}л`
                    };

                    return result[token];
                }
            }
            break
        case 'ar':
            langFile = {
                ...ar,
                formatDistance: (token, count, options) => {
                    const result = {
                        lessThanXSeconds: `${count}с`,
                        xSeconds: `${count}с`,
                        halfAMinute: '0.5м',
                        lessThanXMinutes: `${count}м`,
                        xMinutes: `${count}м`,
                        aboutXHours: `${count}ч`,
                        xHours: `${count}ч`,
                        xDays: `${count}д`,
                        aboutXWeeks: `${count}н`,
                        xWeeks: `${count}н`,
                        aboutXMonths: `${count}мес`,
                        xMonths: `${count}мес`,
                        aboutXYears: `${count}л`,
                        xYears: `${count}л`,
                        overXYears: `${count}л`,
                        almostXYears: `${count}л`
                    };

                    return result[token];
                }
            }
            break
        case 'de':
            langFile = {
                ...de,
                formatDistance: (token, count, options) => {
                    const result = {
                        lessThanXSeconds: `${count}с`,
                        xSeconds: `${count}с`,
                        halfAMinute: '0.5м',
                        lessThanXMinutes: `${count}м`,
                        xMinutes: `${count}м`,
                        aboutXHours: `${count}ч`,
                        xHours: `${count}ч`,
                        xDays: `${count}д`,
                        aboutXWeeks: `${count}н`,
                        xWeeks: `${count}н`,
                        aboutXMonths: `${count}мес`,
                        xMonths: `${count}мес`,
                        aboutXYears: `${count}л`,
                        xYears: `${count}л`,
                        overXYears: `${count}л`,
                        almostXYears: `${count}л`
                    };

                    return result[token];
                }
            }
            break
        case 'fr':
            langFile = {
                ...fr,
                formatDistance: (token, count, options) => {
                    const result = {
                        lessThanXSeconds: `${count}с`,
                        xSeconds: `${count}с`,
                        halfAMinute: '0.5м',
                        lessThanXMinutes: `${count}м`,
                        xMinutes: `${count}м`,
                        aboutXHours: `${count}ч`,
                        xHours: `${count}ч`,
                        xDays: `${count}д`,
                        aboutXWeeks: `${count}н`,
                        xWeeks: `${count}н`,
                        aboutXMonths: `${count}мес`,
                        xMonths: `${count}мес`,
                        aboutXYears: `${count}л`,
                        xYears: `${count}л`,
                        overXYears: `${count}л`,
                        almostXYears: `${count}л`
                    };

                    return result[token];
                }
            }
            break
    }
    return langFile
}

export function $formatDateTime(
    date: string,
    dateTimeFormat = 'dd.MM.yyyy',
) {
    if (!date) return date;
    return format(new Date(date), dateTimeFormat, {
        locale: getLocaleFile()
    });
}

export function $parseDateTime(dateTimeString: string, sourceFormat = 'yyyy-MM-dd') {
    return parse(dateTimeString, sourceFormat, new Date());
}

export function $dateTimeDistance(date: string) {
    if (!date) return "";
    return formatDistance(new Date(date), new Date(), {
        addSuffix: true,
        locale: getLocaleFile(),
    })
}

export function $formatRelative(date: string){
    if (!date) return "";
    //const {locale} = useI18n();

    return formatRelative(new Date(date), new Date(), {
        locale: enUS,
    })
}
